var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.898 42.1021C32.4396 42.1021 41.7959 32.7457 41.7959 21.2041C41.7959 9.66249 32.4396 0.306152 20.898 0.306152C9.35633 0.306152 0 9.66249 0 21.2041C0 32.7457 9.35633 42.1021 20.898 42.1021Z",
    fill: "url(#paint0_linear_1366_1578)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0667 30.7824C16.3896 30.7824 16.5047 30.5267 16.2712 29.8821L14.2803 23.3298L29.6054 14.2382",
    fill: "#C8DAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0667 30.7824C17.5891 30.7824 17.8199 30.5434 18.1115 30.2599L20.8979 27.5505L17.4223 25.4546",
    fill: "#A9C9DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4219 25.4551L25.8438 31.6773C26.8048 32.2076 27.4985 31.933 27.7378 30.7851L31.166 14.6304C31.517 13.2233 30.6296 12.585 29.7102 13.0024L9.58023 20.7645C8.20617 21.3156 8.21418 22.0822 9.32977 22.4238L14.4956 24.0361L26.4549 16.4911C27.0195 16.1487 27.5377 16.3328 27.1124 16.7102",
    fill: "url(#paint1_linear_1366_1578)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1366_1578",
    x1: 15.6756,
    y1: 2.04904,
    x2: 5.22658,
    y2: 26.4286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1366_1578",
    x1: 18.2819,
    y1: 22.4878,
    x2: 20.5148,
    y2: 29.7106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.60e0f5f6174fdb072270f8fb6e9aeb2f.svg";
export { ForwardRef as ReactComponent };